import React, { FC } from "react";
import { FormBaseType } from "@green0meter/api-client";

import Form from "@components/main/co2/hub/Form";

const Co2FormPage: FC = () => <Form formBaseType={FormBaseType.Co2} />;

export default Co2FormPage;
